import { render, staticRenderFns } from "./Form18ProcessHeader.vue?vue&type=template&id=45e3262b&scoped=true"
import script from "./Form18ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form18ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form18ProcessHeader.vue?vue&type=style&index=0&id=45e3262b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3262b",
  null
  
)

export default component.exports